import React from 'react';

import styled from '@emotion/styled';

interface IImg {
  src: string;
  alt?: string;
  className?: string;
}
const Img: React.FC<IImg> = ({ src, alt, className }) => {
  return (
    <Imgg
      className={className}
      loading="lazy"
      src={src}
      alt={alt}
      decoding="async"
    />
  );
};

export default Img;

const Imgg = styled.img`
  width: 100%;
  &.drop-down {
    width: 12px;
  }

  @media (max-width: 480px) {
    // border: 2px solid yellow;
    // object-fit: cover;
    height: 100%;
    width: 100%;
    // width: fit-content;
    // height: fit-content;
  }
`;
